import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export function EmptyState({ icon, title, description, actions }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-16 rounded-lg border border-dashed border-border bg-surface dotgrid">
      {icon && (
        <div className="mb-3 w-10 h-10 rounded-lg bg-surface border border-border flex items-center justify-center text-fg-muted">
          {icon}
        </div>
      )}
      <h3 className="text-md font-semibold text-fg">{title}</h3>
      {description && (
        <p className="text-sm text-fg-muted mt-1 max-w-md">{description}</p>
      )}
      {actions && <div className="mt-4 flex items-center gap-2">{actions}</div>}
    </div>
  );
}
